module.exports = __webpack_public_path__ + "static/media/sun.c7fe6ecb.svg";